<template>
  <div class="row">
    <div class="col-xs-5" >
      <h2 style="margin-top:10px;white-space: nowrap;">{{title}}</h2>
    </div>
    <div  class="col-xs-7" style="font-size:12px;">
      <div style="margin:6px 0px;">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import debug from "debug";
var debug_search_control = debug("esma:title_and_search");
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  beforeMount() {},
  mounted() {},
  afterMount() {},
  beforeDestroy() {},
  props: ["title"],
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// title_and_slot.vue?06f64b34